module.exports = __webpack_public_path__ + "static/media/exames.d1d3bb8a.jpg";